import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScoutViewComponent } from './scout-view/scout-view.component';
import { ScoutPathEditorComponent, UniquePathNumberValidatorDirective } from './scout-path/scout-path-editor/scout-path-editor.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { TaskModule } from '../task/task.module';
import { ScoutPathPlotterComponent } from './scout-path/scout-path-plotter/scout-path-plotter.component';
import { ScoutMarkerPopupComponent } from './scout-path/scout-path-plotter/scout-marker-popup.component';
import { ScoutPointEditorComponent } from './scout-point/scout-point-editor/scout-point-editor.component';
import { ScoutSegmentsEditorComponent } from './scout-path/scout-segments-editor/scout-segments-editor.component';
import { ScoutHeaderComponent } from './scout-header/scout-header.component';
import { ScoutListComponent } from './scout-list/scout-list.component';
import { ScoutEditComponent } from './scout-list/scout-edit/scout-edit.component';
import { ScoutPathCommentsComponent } from './scout-path/scout-path-comments/scout-path-comments.component';
import { ScoutPointRefDialogComponent } from './scout-point/scout-point-ref-dialog/scout-point-ref-dialog.component';
import { ScoutPointPhotoEditorComponent } from './scout-point/scout-point-photo-editor/scout-point-photo-editor.component';
import { ScoutPointPaginatorComponent } from './scout-point/scout-point-paginator/scout-point-paginator.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { createCustomElement } from '@angular/elements';
import { ScoutPointEnvironmentComponent } from './scout-point/scout-point-environment/scout-point-environment.component';
import { ScoutPointRefMeasurementsComponent } from './scout-point/scout-point-ref-measurements/scout-point-ref-measurements.component';
import { LightboxModule } from 'ngx-lightbox';
import { WebcamModule } from 'ngx-webcam';
import { ScoutPathReportComponent } from './scout-path/scout-path-report/scout-path-report.component';
import { ScoutPathImageComponent } from './scout-path/scout-path-report/scout-path-image/scout-path-image.component';
import { ScoutPathAzimuthComponent, ScoutPathAddlAzimuthComponent } from './scout-path/scout-path-azimuth/scout-path-azimuth.component';
import { ScoutPhotosStatusBarComponent } from './scout-point/scout-photos-status-bar/scout-photos-status-bar.component';
import { ScoutPhotosStatusPanelComponent } from './scout-point/scout-photos-status-bar/scout-photos-status-panel.component';
import { ScoutPathOverlayComponent } from './scout-path/scout-path-plotter/scout-path-overlay.component';
import { ScoutPointErrorCalcComponent } from './scout-point/scout-point-error-calc/scout-point-error-calc.component';
import { ScoutPointPhotoBrowserComponent } from './scout-point/scout-point-photo-browser/scout-point-photo-browser.component';
import { ScoutPathEntryReportComponent } from './scout-path/scout-path-entry-report/scout-path-entry-report.component';
import { ScoutPathPointsTableComponent } from './scout-path/scout-path-entry-report/path-points-table/path-points-table.component';
import { ScoutBuildingPointsTableComponent } from './scout-path/scout-path-entry-report/building-points-table/building-points-table.component';
import { ScoutPointPhotoModal } from './scout-point/scout-point-photo-modal/scout-point-photo-modal.component';
import { PathPointParametersTableComponent } from './scout-path/scout-path-report/path-point-parameters-table/path-point-parameters-table.component';
import { TableDropdownFilterComponent } from './scout-path/scout-path-entry-report/scout-data-table/table-dropdown-filter-component'
import { ReactiveComponentModule } from '@ngrx/component';
import { NarikCustomValidatorsModule } from '@narik/custom-validators';
import { ScoutKmlViewerComponent } from './scout-kml-viewer/scout-kml-viewer.component'
import { ScoutKmlViewerModal } from './scout-kml-viewer/scout-kml-viewer-modal/scout-kml-viewer-modal.component';
import { ScoutPointPhotoLinksComponent } from './scout-point-photo-links/scout-point-photo-links.component';

@NgModule({
  declarations: [
    ScoutViewComponent,
    ScoutPathEditorComponent,
    ScoutPathPlotterComponent,
    ScoutSegmentsEditorComponent,
    ScoutPointEditorComponent,
    ScoutHeaderComponent,
    ScoutPathCommentsComponent,
    ScoutPathAzimuthComponent,
    ScoutPathAddlAzimuthComponent,
    ScoutPointRefDialogComponent,
    ScoutPointPaginatorComponent,
    ScoutPointPhotoEditorComponent,
    ScoutListComponent,
    ScoutEditComponent,
    ScoutPointEnvironmentComponent,
    ScoutPointRefMeasurementsComponent,
    ScoutMarkerPopupComponent,
    ScoutPathReportComponent,
    ScoutPathImageComponent,
    ScoutPhotosStatusBarComponent,
    ScoutPhotosStatusPanelComponent,
    ScoutPathOverlayComponent,
    ScoutPointErrorCalcComponent,
    ScoutPointPhotoBrowserComponent,
    ScoutPointPhotoModal,
    ScoutPathEntryReportComponent,
    ScoutPathPointsTableComponent,
    ScoutBuildingPointsTableComponent,
    PathPointParametersTableComponent,
    TableDropdownFilterComponent,
    UniquePathNumberValidatorDirective,
    ScoutKmlViewerComponent,
    ScoutKmlViewerModal,
    ScoutPointPhotoLinksComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NarikCustomValidatorsModule,
    LeafletModule,
    LightboxModule,
    BsDropdownModule.forRoot(),
    ReactiveComponentModule,
    WebcamModule,
    SharedModule,
    TaskModule
  ],
  exports: [
    ScoutViewComponent,
    ScoutPathEditorComponent,
    ScoutPointEditorComponent,
    ScoutPathPlotterComponent,
    ScoutPointRefDialogComponent,
    ScoutListComponent,
    ScoutEditComponent,
    ScoutPhotosStatusBarComponent,
    ScoutPhotosStatusPanelComponent,
    ScoutPathReportComponent,
    ScoutPathEntryReportComponent,
    ScoutPointPhotoBrowserComponent,
    ScoutPointPhotoModal,
    ScoutKmlViewerModal,
    ScoutPointPhotoLinksComponent,
    ScoutPointPhotoEditorComponent,
    ScoutPathOverlayComponent,
  ],
  entryComponents: [ ScoutMarkerPopupComponent ] // needed for electron (leaflet marker popup needs ngIf from common module)
})
export class ScoutModule {
  constructor(private injector: Injector) {
    // The scout-path-plotter component creates a module to load the marker popup in its contstructor
    const popupElement = createCustomElement(ScoutMarkerPopupComponent, {injector});
    customElements.define('app-marker-popup-element', popupElement);
  }
 }

